
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VWrapper from '@/components/shared/VWrapper.vue';
import ReleasesTable from '@/components/releases/ReleasesTable.vue';
import { namespace } from 'vuex-class';
import Filter from '@/interfaces/api/Filter';
import { Release as ReleaseModel } from '@/interfaces/models/Release';
import { Venue } from '@/interfaces/models/Venue';
import CustomerGroup from '@/mixins/CustomerGroup';

const releases = namespace('releases');
const venue = namespace('venue');

@Component({
  components: { VWrapper, ReleasesTable },
})
export default class Releases extends mixins(CustomerGroup) {
  @releases.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @releases.Action('fetch') public getItems!: any;
  @releases.Action('delete') public deleteRelease!: any;

  @releases.State((state) => state.pagination.total) public total!: number;
  @releases.State('filter') public filter!: Filter;
  @releases.State('items') public items!: [];
  @venue.State('active') public venue!: Venue;

  public async mounted() {
    if (!this.filter?.customerGroup) {
      return;
    }

    this.$startLoading('releases');
    await this.getItems({ page: 1 });
    this.$stopLoading('releases');
  }

  public async onFilter(val: object) {
    this.$startLoading('releases');
    this.setFilter(val);
    await this.getItems({ page: 1 });
    this.$stopLoading('releases');
  }

  public async remove(release: ReleaseModel) {
    this.$startLoading('releases');
    await this.deleteRelease({ id: release._id });
    this.$stopLoading('releases');
  }

  public edit(item: ReleaseModel) {
    this.$router.push({
      name: 'releases.edit',
      params: { id: item._id },
      query: { ...this.$route.query },
    });
  }
}
